import { render } from "./Click11PlusShortIcon.vue?vue&type=template&id=1bdd2ce2"
import script from "./Click11PlusShortIcon.vue?vue&type=script&lang=js"
export * from "./Click11PlusShortIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__